import { TokenType } from './tokenizer';

export const PolishNotation = <T extends { type: string | number }>(tokens: T[]) => {
  const queue: T[] = [];
  const stack: T[] = [];
  tokens.forEach(token => {
    switch (token.type) {
      case TokenType.LITERAL:
        queue.unshift(token);
        break;
      case TokenType.NOT:
      case TokenType.AND:
      case TokenType.OR:
      case TokenType.EQUALS:
      case TokenType.PAR_OPEN:
        stack.push(token);
        break;
      case TokenType.PAR_CLOSE:
        while (stack.length && stack[stack.length - 1]?.type !== TokenType.PAR_OPEN) {
          queue.unshift(stack.pop()!);
        }

        stack.pop();

        if (stack.length && stack[stack.length - 1]?.type === TokenType.NOT) {
          queue.unshift(stack.pop()!);
        }
        break;
      default:
        break;
    }
  });

  return (stack.length && [...stack.reverse(), ...queue]) || queue;
};

export interface IPolish {
  type: string | number;
  value: string;
}

export const PolishGenerator = function* (polish: IPolish[]) {
  for (let index = 0; index < polish.length - 1; index++) {
    yield polish[index];
  }

  return polish[polish.length - 1];
};
